// extracted by mini-css-extract-plugin
module.exports = {"adornmentError":"Description_adornmentError__1mtPd","adornmentWarn":"Description_adornmentWarn__3o4rf","fadeIn":"Description_fadeIn__3PwCR","fadeOut":"Description_fadeOut__3qU_N"};